/**
 * 延迟执行, 防止短时间内频繁执行
 * @constructor
 */
let Delay = function() {
  this.timer = null
}
Delay.prototype = {
  run: function(fun, timeDelay) {
    let self = this
    if (self.timer) {
      window.clearTimeout(self.timer)
    }
    self.timer = window.setTimeout(fun, timeDelay)
  },
}

/**
 * deferred
 * @constructor
 * @example
 * deferredObject.done(function(){...})[.fail(function(){...})]
 */
function Deferred() {
  this._done = []
  this._fail = []
}

Deferred.prototype = {
  execute: function(list, args) {
    let i = list.length
    args = Array.prototype.slice.call(args)
    while (i--) {
      list[i].apply(null, args)
    }
  },
  resolve: function() {
    this.execute(this._done, arguments)
  },
  reject: function() {
    this.execute(this._fail, arguments)
  },
  done: function(callback) {
    this._done.push(callback)
    return this
  },
  fail: function(callback) {
    this._fail.push(callback)
    return this
  },
  onOk: function(callback) {
    return this.done(callback)
  },
  onCancel: function(callback) {
    return this.fail(callback)
  },
}

/**
 * 颜色渐变值计算
 * @param {*} start
 * @param {*} end
 * @param {*} maxValue
 * @param {*} minValue
 */
function ColorGrading(
  maxValue,
  minValue = 0,
  start = [182, 243, 240],
  end = [0, 122, 141]
) {
  maxValue = maxValue || 10
  var step = (this.step = [])
  start.forEach((v, i) => {
    step[i] = (end[i] - v) / maxValue
  })
  this.min = minValue
  this.start = start
  this.max = maxValue
}
ColorGrading.prototype.getColor = function(value, opacity = 255) {
  if (value > this.max) {
    value = this.max
  }
  let res = []
  let { step, start, min } = this
  step.forEach((v, i) => {
    let nv = Math.floor(start[i] + v * (value - min))
    if (nv < 0) {
      nv = 0
    } else if (nv > 255) {
      nv = 255
    }
    res[i] = nv
  })
  if (res.length === 3) {
    res.push(opacity)
  }
  return res
}
ColorGrading.prototype.getStartColor = function() {
  return this.start
}
export default {
  go: function() {
    // browserHistory.push (path)
  },
  Delay: Delay,
  Deferred: Deferred,
  serializeParam: function(param) {
    let paramString = []
    for (let k in param) {
      paramString.push([k, param[k]].join("="))
    }
    return paramString.join("&")
  },

  /**
   * 类型判断
   * @param obj
   * @returns {string}
   */
  typeOf: function(obj) {
    return {}.toString
      .call(obj)
      .split(" ")[1]
      .slice(0, -1)
      .toLowerCase()
  },
  /**
   * 楼层名字转化
   * @param floor
   * @returns {string}
   */
  getFloorName: function(floor) {
    return floor > 0 ? floor + "F" : "B" + Math.abs(floor)
  },
  /**
   * 根据窗口宽度计算字体大小
   * @param min
   * @param max
   * @returns {number}
   */
  getResizeFontSize: function(min, max) {
    let width = document.body.offsetWidth
    if (width > max) {
      width = max
    }
    return width / 10
  },
  /**
   * 数字增加千分号
   * @param data
   */
  dataWithComma: function(data) {
    if (!data) {
      return 0
    }
    var reg = /(\d{1,3})(?=(\d{3})+(\.\d*)?$)/g
    var num = data + ""
    return num.replace(reg, "$1,")
  },
  ISO8601: function(time) {
    return time.format().replace(/:(\d{2})$/, "$1")
  },
  ColorGrading,
  addEventOnResize: function(fn) {
    var originFn = window.onresize
    window.onresize = function() {
      originFn && originFn()
      fn()
    }
  },
  parseQuery(qs) {
    let res = {}
    if (qs) {
      qs = qs.replace("?", "")
      if (qs) {
        qs.split("&").forEach(p => {
          let para = p.split("=")
          res[para[0]] = para[1]
        })
      }
    }
    return res
  },
}
